export const buildDiscountMethods = (
  client,
  { getCheckoutID, setLocalCheckout },
) => ({
  add: async (codeToAdd) => {
    const newCheckout = await client.checkout.addDiscount(
      getCheckoutID(),
      codeToAdd,
    )
    await setLocalCheckout(newCheckout)
  },
  remove: async () => {
    const newCheckout = await client.checkout.removeDiscount(getCheckoutID())
    await setLocalCheckout(newCheckout)
  },
})
